import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import {
  ITableActionOptions,
  ITableBadgeColumnOptions,
  ITableColumn,
  ITablePagenationOptions,
} from "../interfaces/SharedTable";
import { TaskPriority } from "../interfaces/TaskStatus";

@Component({
  selector: "app-shared-table",
  templateUrl: "./shared-table.component.html",
  styleUrls: ["./shared-table.component.scss"],
})
export class SharedTableComponent implements OnInit, OnChanges, AfterViewInit {
  // :Output events
  @Output() triggerRowActionClick: EventEmitter<any> = new EventEmitter();
  @Output() triggerPagenationChange: EventEmitter<any> = new EventEmitter();

  //: Input events
  @Input() columnData: ITableColumn[];
  @Input() dataSourceArray: any[];
  @Input() actionColumnOptions: ITableActionOptions;
  @Input() pagenationOptions: ITablePagenationOptions;
  @Input() searchString: string;
  // @Input() badgeColumnOptions:ITableBadgeColumnOptions;
  @Input() totalCount: number;

  columnsDefs: Array<any>;
  dataSource: MatTableDataSource<any>;
  displayedColumns: Array<any>;
  actionColumn: ITableActionOptions;
  // badgeColumn:ITableBadgeColumnOptions;

  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  activeInvoices: any[] = [];
  loading: boolean = true;
  total_count: number = 0;
  page_count: number = 1;
  pageIndex = 0;
  page_size: number;
  pageSizeOptions: number[];
  currency = localStorage.getItem("base_currency");

  constructor() {
    this.dataSource = new MatTableDataSource<any>();
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.columnData) {
      this.displayedColumns = this.columnData.filter((ob) => ob.bShow);
      this.columnsDefs = this.columnData
        .filter((ob) => ob.bShow)
        .map((ob) => ob.key);
    }
    if (this.dataSourceArray) {
      this.dataSource.data = this.dataSourceArray;
    }
    if (this.actionColumnOptions) {
      this.actionColumn = this.actionColumnOptions;
    }
    // if(this.badgeColumnOptions){
    //   this.badgeColumn = this.badgeColumnOptions
    // }
    // if(this.badgeColumn.bShow){
    //   this.columnsDefs = this.columnsDefs.concat([this.badgeColumn.key]);
    // }
    if (this.actionColumn.bShow) {
      this.columnsDefs = this.columnsDefs.concat([this.actionColumn.key]);
    }
    if (this.pagenationOptions) {
      this.page_size = this.pagenationOptions.pageSize;
      this.pageSizeOptions = this.pagenationOptions.pageSizeOptions;
    }
    if (changes?.totalCount) {
      const currentCount = changes.totalCount?.currentValue;
      const previousCount = changes.totalCount?.previousValue;
      if (currentCount !== previousCount) {
        if (this.paginator) {
          this.paginator.length = currentCount;
        }

        this.totalCount = currentCount;
      }
    }
    this.applySearchFilter(this.searchString);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.paginator.length = this.totalCount;
  }

  paginationChange(event: any) {
    console.log(event);
    this.triggerPagenationChange.emit(event);
    // this.page_size = event.pageSize;
    // if (event?.previousPageIndex > event.pageIndex) {
    //   this.page_count = this.page_count - 1;

    //   this.getAllBids().then((result) => {
    //     this.paginator.length = event.length = this.total_count;
    //   });
    // } else if (event?.previousPageIndex < event.pageIndex) {
    //   this.paginator.length = event.length = this.total_count;

    //   this.page_count += 1;

    //   this.getAllBids().then((result) => {
    //     this.paginator.length = event.length = this.total_count;
    //   });
    // } else {
    //   this.getAllBids().then((result) => {
    //     this.paginator.length = event.length = this.total_count;
    //   });
    // }
  }

  applySearchFilter(searchString: string) {
    if (searchString) {
      this.dataSource.filter = searchString.toLowerCase();
    }
  }

  actionCellClick(element: any) {
    this.triggerRowActionClick.emit(element);
  }

  isString(value: any): boolean {
    return typeof value === "string";
  }

  isArray(value: any): boolean {
    return Array.isArray(value);
  }

  getBadgePillColor(priority: string) {
    switch (priority.toLowerCase()) {
      case TaskPriority.URGENT.toLowerCase():
        return "#F32828";
      case TaskPriority.HIGH.toLowerCase():
        return "#E8702D";
      case TaskPriority.MEDIUM.toLowerCase():
        return "#1976D2";
      default:
        return "#808488";
    }
  }
}
